// extracted by mini-css-extract-plugin
export var container = "_e1-0";
export var icon = "_e1-1";
export var text = "_e1-2";